import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../lib/api';

const WholesaleContext = createContext();

export const useWholesale = () => {
  const context = useContext(WholesaleContext);
  if (!context) {
    throw new Error('useWholesale must be used within a WholesaleProvider');
  }
  return context;
};

export const WholesaleProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('wholesale_token'));
  const [loading, setLoading] = useState(true);

  const clearAuth = () => {
    setToken(null);
    setClient(null);
    localStorage.removeItem('wholesale_token');
  };

  // Check token validity on mount
  useEffect(() => {
    const validateToken = async () => {
      if (token) {
        try {
          const profile = await api.getWholesaleProfile(token);
          setClient(profile);
        } catch (error) {
          console.error('Token validation failed:', error);
          clearAuth();
        }
      }
      setLoading(false);
    };
    validateToken();
  }, [token]);

  const login = async (email, password) => {
    const response = await api.wholesaleLogin(email, password);
    setToken(response.access_token);
    setClient(response.client);
    localStorage.setItem('wholesale_token', response.access_token);
    return response;
  };

  const register = async (clientData) => {
    const response = await api.wholesaleRegister(clientData);
    return response;
  };

  const logout = () => {
    clearAuth();
  };

  const value = {
    client,
    token,
    loading,
    isAuthenticated: !!client,
    login,
    register,
    logout,
  };

  return (
    <WholesaleContext.Provider value={value}>
      {children}
    </WholesaleContext.Provider>
  );
};
